export default __webpack_public_path__ + "static/media/img_rotatephone.min.de3fbbb2.svg";